// extracted by mini-css-extract-plugin
export default {"notfound":"Error404_notfound__Q1swE","notfound404":"Error404_notfound404__OSwDj"};